// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2AC3e","selected":"Chip_selected__3y5fZ"};